import React from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Upload, X } from "lucide-react";

const ImageUploadField = ({
  images,
  imageCount,
  handleImageChange,
  removeImage,
  isSubmitting
}) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="partImagesInput">Part Images (Optional)</Label>
      <p className="text-xs text-muted-foreground">
        You can upload up to <span className="font-medium">5 images</span>. Each
        image must be under <span className="font-medium">5MB</span>.
      </p>

      <div className="flex items-center gap-4">
        <Label
          htmlFor="partImagesInput"
          className={`flex-shrink-0 cursor-pointer inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 border border-input bg-background hover:bg-accent hover:text-accent-foreground h-8 xs:h-10 px-4 py-1.5 xs:py-2 ${
            imageCount >= 5 || isSubmitting
              ? "opacity-50 cursor-not-allowed"
              : ""
          }`}
        >
          <Upload className="mr-2 h-4 w-4" /> Choose Images
        </Label>
        <Input
          id="partImagesInput"
          type="file"
          multiple
          accept="image/*"
          onChange={handleImageChange}
          className="hidden"
          disabled={imageCount >= 5 || isSubmitting}
        />
        <span className="text-sm text-muted-foreground">
          {imageCount} / 5
          <span className="hidden xs:inline"> images selected</span>
        </span>
      </div>

      {images.length > 0 && (
        <div className="mt-4 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
          {images.map((image, index) => (
            <div key={index} className="relative group aspect-w-1 aspect-h-1">
              <img
                alt={`Preview ${index + 1}`}
                className="w-full h-full object-cover rounded-md border border-border"
                src={image.preview}
              />
              <Button
                type="button"
                variant="destructive"
                size="icon"
                className="absolute top-1 right-1 h-6 w-6 opacity-0 group-hover:opacity-100 transition-opacity rounded-full"
                onClick={() => removeImage(index)}
                disabled={isSubmitting}
              >
                <X className="h-4 w-4" />
                <span className="sr-only">Remove</span>
              </Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ImageUploadField;
